import React, { useEffect, useState } from "react";
import { Button, ControlLabel, FormControl, FormGroup, Glyphicon, ListGroupItem } from "react-bootstrap";
import Select from "react-select";

import { viewTypeRestrictionsLists } from "../models";
import * as Api from "../../../../../api/cp/eventViewingRestriction";
import { validateIpField } from "../utils/validateIpAddress";
import HelpHintButton from "components/HelpHintButton";
import DeleteConfirmOverlay from "../../../UI/DeleteConfirmOverlay";

const AccessByIpSettings = ({ locale, eventKey, filter, isSaving, onSaveFilter }) => {
    const [ipAddress, setIpAddress] = useState('');
    const [ipAddressesList, setIpAddressesList] = useState([]);

    useEffect(() => {
        !!filter && fetchIpAddressesList(filter);
    }, [filter]);

    async function fetchIpAddressesList(type) {
        try {
            const response = await Api.getIpAddressesList(eventKey, type);
            setIpAddressesList(response || []);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleSaveIpAddress() {
        if (!validateIpField(ipAddress)) {
            return;
        }

        try {
            const response = await Api.addIpAddress(eventKey, { type: filter, value: ipAddress });

            if (!ipAddressesList.find(({ id }) => id === response.id)) {
                setIpAddressesList((prevState) => ([...prevState, response]));
            }

            setIpAddress('');
        } catch (error) {
            console.error(error);
        }
    }

    async function handleDeleteIpAddress(id) {
        try {
            await Api.deleteIpAddress(id);
            setIpAddressesList((prevState) => prevState.filter((ip) => ip.id !== id));
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div>
            <ControlLabel>
                {locale('settings.viewTypeRestriction.byIp.title')}
                <HelpHintButton>
                    {locale('settings.viewTypeRestriction.byIp.hint')}
                </HelpHintButton>
            </ControlLabel>
            <FormGroup style={{ display: 'grid', gridTemplateColumns: '200px 1fr 200px', columnGap: '12px' }}>
                <Select
                    value={viewTypeRestrictionsLists.find(({ value }) => value === filter)}
                    placeholder="Выберите тип списка"
                    isDisabled={isSaving}
                    options={viewTypeRestrictionsLists}
                    onChange={({ value }) => onSaveFilter({ ipFilter: value })}
                />
                <FormControl
                    type="text"
                    placeholder={locale('settings.viewTypeRestriction.selectType')}
                    value={ipAddress}
                    disabled={isSaving}
                    style={{ height: '38px' }}
                    onChange={(e) => setIpAddress(e.target.value)}
                />
                <Button
                    disabled={!filter || !ipAddress || isSaving}
                    onClick={handleSaveIpAddress}
                >
                    <Glyphicon glyph="plus" /> {locale('settings.viewTypeRestriction.byIp.button')}
                </Button>
            </FormGroup>
            <p>
                <i>
                    * {locale('settings.viewTypeRestriction.byIp.validationHint')}
                </i>
            </p>
            {ipAddressesList?.map(({id, value}) => (
                <ListGroupItem
                    key={id}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 10px' }}
                >
                    {value}
                    <DeleteConfirmOverlay
                        title={locale('settings.viewTypeRestriction.byIp.confirm')}
                        buttonText={locale('message.control.delete')}
                        onConfirm={() => handleDeleteIpAddress(id)}
                    >
                        <Button>
                            <Glyphicon glyph="trash" />
                        </Button>
                    </DeleteConfirmOverlay>
                </ListGroupItem>
            ))}
        </div>
    );
};

export default AccessByIpSettings;
